import { Component, ContentChild, Input, TemplateRef } from '@angular/core'
import { DEFAULT_TIMEZONE } from '@mmx/shared'
import moment from 'moment-timezone'
import { Observable } from 'rxjs'

export type HistoryDay<T> = { date: moment.Moment; logs: T[] }

@Component({
  selector: 'mmx-history-dialog',
  templateUrl: './history-dialog.component.html',
  styleUrls: ['./history-dialog.component.scss'],
  standalone: false,
})
export class HistoryDialogComponent<T = unknown> {
  @Input() title = ''
  @Input() history$!: Observable<HistoryDay<T>[]>
  @Input() loading$!: Observable<boolean>
  @Input() emptyText = 'No history available.'
  @Input() tz = DEFAULT_TIMEZONE
  @Input() logRowClass = ''

  @ContentChild(TemplateRef) public logTemplate?: TemplateRef<{ $implicit: T; log: T; day: HistoryDay<T> }>

  public calendarFormats = {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastDay: '[Yesterday]',
    lastWeek: '[Last] dddd',
    sameElse: 'MM/DD/YYYY',
  }
}
